import { Builder } from "@builder.io/react";
import SwellProductsList from "./SwellProductsList";

Builder.registerComponent(SwellProductsList, {
  name: "SwellProductsList",
  inputs: [],
});
